import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export type SubtitleCueType = {
  endTime: number;
  startTime: number;
  text: string;
};

export type CurrentSubtitleTrackType = {
  activeCues: SubtitleCueType[] | null;
  cues: SubtitleCueType[] | null;
  kind: string;
  label: string;
  language: string;
  mode: 'disabled' | 'showing';
};

export type CaptionLanguagesType = {
  default: boolean;
  src: string;
  srcLang: string;
};

export const currentSubtitleTrack = atomWithReset<CurrentSubtitleTrackType>({
  activeCues: null,
  cues: null,
  kind: '',
  label: '',
  language: '',
  mode: 'disabled',
});

export const videoSpeed = atomWithReset<number>(1.0);

export const videoSound = atomWithReset<number>(100);

export const currentSubtitleCue = atomWithReset<SubtitleCueType | undefined>({
  endTime: 0,
  startTime: 0,
  text: '',
});

export const allLanguages = atomWithReset<CaptionLanguagesType[]>([
  {
    default: false,
    src: '',
    srcLang: '',
  },
]);

export const trackLang = atomWithReset<CaptionLanguagesType>({
  default: false,
  src: '',
  srcLang: '',
});

export const contentType = atom<string>('');

export const currentPage = atom<number>(-1);

export const totalPages = atom<number>(0);

export const progress = atom<number>(0);

export const scale = atom<number>(1.0);

export const rotation = atom<number>(0);

export const isAppbarVisible = atom<boolean>(true);

export const isSubtitleVisible = atom<boolean>(false);

/** task-0294: intrinsic 세로>가로(tall)일 때만 0226 portrait pin 해제 */
export const isTallVideo = atom<boolean>(false);

export const seekTo = atom<number | undefined>(undefined);

/** CustomVideoPlayer ±10 / 데스크탑 Arrow seek 공통 상한(초). 스킵 허용 시 duration. */
export const seekUpperBound = atom<number>(Number.POSITIVE_INFINITY);

export const isFullscreen = atom<boolean>(false);
